import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useStore } from '@base-ui/utils/store/useStore';
import { schedulerEventSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { isInternalDragOrResizePlaceholder } from '@mui/x-scheduler-headless/internals';
import { processDate } from '@mui/x-scheduler-headless/process-date';
import { useAdapterContext } from '@mui/x-scheduler-headless/use-adapter-context';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { timelineOccurrencePlaceholderSelectors } from "../../event-timeline-premium-selectors/index.mjs";
export function usePlaceholderInRow(parameters) {
  const {
    occurrences,
    maxIndex,
    resourceId
  } = parameters;

  // Context hooks
  const adapter = useAdapterContext();
  const store = useEventTimelinePremiumStoreContext();

  // Selector hooks
  const rawPlaceholder = useStore(store, timelineOccurrencePlaceholderSelectors.placeholderInResource, resourceId);
  const originalEventId = isInternalDragOrResizePlaceholder(rawPlaceholder) ? rawPlaceholder.eventId : null;
  const originalEvent = useStore(store, schedulerEventSelectors.processedEvent, originalEventId);
  return React.useMemo(() => {
    if (!rawPlaceholder) {
      return null;
    }
    const startProcessed = processDate(rawPlaceholder.start, adapter);
    const endProcessed = processDate(rawPlaceholder.end, adapter);
    const timezone = adapter.getTimezone(rawPlaceholder.start);
    const sharedProperties = {
      id: originalEventId ?? 'occurrence-placeholder',
      key: 'occurrence-placeholder',
      title: originalEvent ? originalEvent.title : '',
      resource: rawPlaceholder.resourceId ?? originalEvent?.resource,
      displayTimezone: {
        start: startProcessed,
        end: endProcessed,
        timezone
      }
    };
    if (rawPlaceholder.type === 'creation') {
      return _extends({}, sharedProperties, {
        position: {
          firstIndex: 1,
          lastIndex: maxIndex
        }
      });
    }
    if (rawPlaceholder.type === 'external-drag') {
      return _extends({}, sharedProperties, {
        title: rawPlaceholder.eventData.title ?? '',
        position: {
          firstIndex: 1,
          lastIndex: maxIndex
        }
      });
    }
    const position = occurrences.find(occurrence => occurrence.key === rawPlaceholder.occurrenceKey)?.position ?? {
      firstIndex: 1,
      lastIndex: maxIndex
    };
    return _extends({}, sharedProperties, {
      position
    });
  }, [rawPlaceholder, adapter, originalEvent, originalEventId, occurrences, maxIndex]);
}